import { Typography } from '@mui/material';
import { LocalGasStation } from '@mui/icons-material';

/**
 * Empty state component displayed when no stations are found
 * Shows a gas station icon with helpful message about double-clicking to open profiles
 * 
 * @returns JSX element containing empty state UI with icon and instructions
 */
export function EmptyState() {
  return (
    <div className="azk-list-empty-state">
      <LocalGasStation className="azk-list-empty-icon" />
      <Typography>АЗК не знайдено</Typography>
      <Typography className="azk-list-empty-subtitle">
        Двічі клацніть на рядок для відкриття профілю АЗК
      </Typography>
    </div>
  );
}
